import React, { useEffect, useMemo, useState } from "react"

import axios from "axios"

import { STATUS_PROMO_LIVE, STATUS_PROMO_OVER, STATUS_PROMO_SOON } from "../config"

import Spinner from "./elements/Spinner"
import { getEnvConfig } from "../env"
import Promosoon from "../nav/Promosoon"
import Promoover from "../nav/Promoover"

interface PromoOverRedirectProps {
	children: any
}

export const hasTestingParam = (): boolean => {
	if (typeof window === "undefined") return false

	const params = new URLSearchParams(window.location.search)
	return params.get("testing") === "l4tYpNBIRTdRF4"
}

const PromoSoonOverHandler: React.FC<PromoOverRedirectProps> = ({ children }) => {
	const [promoStatus, setPromoStatus] = useState<string | null>(null)

	useEffect(() => {
		const isTesting = hasTestingParam()

		const env = getEnvConfig()

		if (isTesting) {
			setPromoStatus(STATUS_PROMO_LIVE)
		} else {
			axios
				.get(env.apibase + "promoStatus.php")
				.then(res => {
					if (res.data.status) {
						setPromoStatus(res.data.status)
					} else {
						setPromoStatus(STATUS_PROMO_SOON)
					}
				})
				.catch(res => {
					// Fallback, if Strapi is down
					setPromoStatus(STATUS_PROMO_SOON)
				})
		}
		// eslint-disable-next-line
	}, [])

	const view = useMemo(() => {
		if (promoStatus === STATUS_PROMO_SOON) return <Promosoon />
		if (promoStatus === STATUS_PROMO_OVER) return <Promoover />
		return children
	}, [promoStatus, children])

	return (
		<>
			{promoStatus ? (
				view
			) : (
				<div className="text-center py-12">
					<Spinner />
				</div>
			)}
		</>
	)
}

export default PromoSoonOverHandler
